import { generatePath, Link } from "react-router-dom";
import { EMPLOYEE_PROFILE_PATH } from "./employee-profile-path";
import { ReactNode } from "react";

export function ToEmployeeProfileLink({
  id,
  className,
  children,
}: {
  id?: string;
  className?: string;
  children: ReactNode;
}) {
  if (!id) {
    return children;
  }

  return (
    <Link
      to={generatePath(EMPLOYEE_PROFILE_PATH, {
        id,
      })}
      className={className}
    >
      {children}
    </Link>
  );
}
